<template lang="pug">
  v-tooltip(
    :disabled="!value"
    v-bind="config"
  )
    template(v-slot:activator="activator")
      .d-inline-block(v-on="activator.on")
        slot(
          v-bind="activator"
        )
    slot(name="reason")
      span.white--text.text--darken-2.caption {{ text }}
</template>

<script>
export default {
  name: 'TooltipWrap',
  props: {
    value: { type: Boolean, default: true },
    text: { type: String, default: 'Неактивно' },
  },
  computed: {
    config() {
      const config = {
        top: true,
      };
      return {
        ...config,
        ...this.$attrs,
      };
    },
  },
};
</script>
